// extracted by mini-css-extract-plugin
export default {"root":"FormFilterInner_root__I4ri1","label":"FormFilterInner_label__o5NF2","tags":"FormFilterInner_tags__GRiav"};